<template>
    <section class="page3">
        <div class="conteudo-reverse text-left">
            <div class="col1 text-white">
                <p class="text-big text-bold">
                    Preencha o formulário e acesse o conteúdo gratuitamente.
                </p>
                <p class="p2">
                    Preparamos um guia para apoiar você a dar os
                    primeiros passos em direção a um processo de RH alinhado com
                    a LGPD.
                </p>
                <p class="text-bold text-sm p1" v-if="sucesso && !falha">
                    Obrigado. Formulário enviado com sucesso!
                </p>
                <p
                    class="text-bold text-sm p1"
                    data-aos="fadeIn"
                    v-if="falha && !sucesso"
                >
                    Ops! Ocorreu um erro ao enviar o seu formulário, tente
                    novamente.
                </p>
                <form
                    id="form"
                    class="p1"
                    @submit="submitForm($event)"
                    v-on:input="checkInput()"
                >
                    <input
                        class="campoForm"
                        placeholder="Nome"
                        v-model="form.nome"
                        type="text"
                        name="nome"
                        min-length="8"
                        required
                        @keypress="preventNumber($event)"
                    />

                    <input
                        class="campoForm"
                        placeholder="Sobrenome"
                        v-model="form.sobrenome"
                        type="text"
                        name="sobrenome"
                        required
                        @keypress="preventNumber($event)"
                    />

                    <input
                        class="campoForm"
                        placeholder="E-mail Corporativo"
                        v-model="form.email"
                        type="email"
                        name="email"
                        required
                    />

                    <select @click="checkInput()"
                        class="campoForm select"
                        placeholder="Número de Funcionários"
                        :class="{ selectAlt: form.nfunc != null }"
                        required="required"
                        name="nfunc"
                        v-model="form.nfunc"
                    >
                        <option
                            value="null"
                            class="defaultSelect"
                            disabled
                            selected="selected"
                            hidden
                        >
                            Número de Funcionários
                        </option>
                        <option value="Até 100">Até 100</option>
                        <option value="101-1000">101-1000</option>
                        <option value="1001-2500">1001-2500</option>
                        <option value="2501-5000">2501-5000</option>
                        <option value="Acima de 5000">Acima de 5000</option>
                    </select>

                    <input
                        class="campoForm"
                        placeholder="Empresa"
                        v-model="form.empresa"
                        type="text"
                        name="empresa"
                        required
                    />

                   
                    <select  @click="checkInput()"
                        class="campoForm select"
                        :class="{ selectAlt: form.cargo != null }"
                        required="required"
                        name="cargo"
                        v-model="form.cargo"
                    >
                        <option
                            value="null"
                            selected="selected"
                            disabled
                            hidden
                        >
                            Cargo
                        </option>
                        <option value="Analista">Analista</option>

                        <option value="Assistente">Assistente</option>

                        <option value="Coordenador (a)">Coordenador (a)</option>

                        <option value="Trainee/Estagiário (a)">Trainee/Estagiário (a)</option>

                        <option value="Diretor (a)">Diretor (a)</option>

                        <option value="Gerente">Gerente</option>

                        <option value="Presidente">Presidente</option>

                    </select>

                    <!-- <input
                        class="campoForm"
                        placeholder="Departamento"
                        v-model="form.departamento"
                        type="text"
                        name="departamento"
                        required
                    /> -->
                     <select  @click="checkInput()"
                        class="campoForm select"
                        :class="{ selectAlt: form.departamento != null }"
                        required="required"
                        name="departamento"
                        v-model="form.departamento"
                    >
                        <option
                            value="null"
                            selected="selected"
                            disabled
                            hidden
                        >
                            Departamento
                        </option>

                        <option value="Administrativo">Administrativo</option>

                        <option value="Comercial">Comercial</option>

                        <option value="Compras">Compras</option>

                        <option value="Contabilidade">Contabilidade</option>

                        <option value="Pessoal">Pessoal</option>

                        <option value="Recursos Humanos">Recursos Humanos</option>

                        <option value="Presidência">Presidência</option>

                        <option value="Tecnologia da Informação">Tecnologia da Informação</option>

                        <option value="Outro">Outro</option>

                    </select>

                    <input
                        class="campoForm"
                        placeholder="Cidade"
                        v-model="form.cidade"
                        type="text"
                        name="cidade"
                        required
                    />

                    <select  @click="checkInput()"
                        class="campoForm select"
                        :class="{ selectAlt: form.estado != null }"
                        name="estado"
                        required="required"
                        v-model="form.estado"
                    >
                        <option
                            value="null"
                            selected="selected"
                            disabled
                            hidden
                        >
                            Estado
                        </option>
                        <option value="AC">AC</option>
                        <option value="AL">AL</option>
                        <option value="AM">AM</option>
                        <option value="AP">AP</option>
                        <option value="BA">BA</option>
                        <option value="CE">CE</option>
                        <option value="DF">DF</option>
                        <option value="ES">ES</option>
                        <option value="GO">GO</option>
                        <option value="MA">MA</option>
                        <option value="MG">MG</option>
                        <option value="MS">MS</option>
                        <option value="MT">MT</option>
                        <option value="PA">PA</option>
                        <option value="PB">PB</option>
                        <option value="PE">PE</option>
                        <option value="PI">PI</option>
                        <option value="PR">PR</option>
                        <option value="RJ">RJ</option>
                        <option value="RN">RN</option>
                        <option value="RS">RS</option>
                        <option value="RO">RO</option>
                        <option value="RR">RR</option>
                        <option value="SC">SC</option>
                        <option value="SE">SE</option>
                        <option value="SP">SP</option>
                        <option value="TO">TO</option>
                    </select>

                    <the-mask
                        class="campoForm"
                        placeholder="Telefone (00) 0000-0000"
                        v-model="form.telefone"
                        type="tel"
                        name="telefone"
                        @keypress="isNumber($event)"
                        :mask="['(##) ####-####', '(##) #####-####']"
                        required
                    />
                    
                    <div class="checkBox">
                        <input @click="checkBox($event)" type="checkbox" name="opt-in" :value="checkBoxValue">
                        <label for="opt-in" class="text-bold">Eu concordo que a LG lugar de gente me envie comunicações de marketing</label>
                        <p class="text-sm p1">Você está fornecendo o seu consentimento para a LG lugar de gente para que possamos enviar comunicações de marketing. Você pode revogar o seu consentimento a qualquer momento. Para mais informações, consulte nossa <a class="text-yellow" href="https://www.lg.com.br/lps/privacidade/">Política de Privacidade.</a></p>
                    </div>
                    <input type="hidden" name="formPard" value="https://pages.lg.com.br/l/688633/2020-11-03/f8j32" />
                        
                    <input
                        class="btnEnviarDisabled buttonAlign"
                        :class="{ btnEnviarEnabled: submitActive == true }"
                        type="submit"
                        value="Enviar"
                    />
                </form>
            </div>
            <div class="col2">
                <img src="~@/assets/img/page2-img.png" alt="" />
            </div>
        </div>
    </section>
</template>

<script>
window.axios = require("axios");

export default {
    data() {
        return {
            piAId: "689633",
            piCId: "1611",
            piHostname: "pi.pardot.com",
            form: {
                nome: null,
                sobrenome: null,
                email: null,
                empresa: null,
                nfunc: null,
                cargo: null,
                departamento: null,
                cidade: null,
                estado: null,
                telefone: null,
                "opt-in":"off",
                "formPard":"https://pages.lg.com.br/l/688633/2020-11-03/f8j32"
            },
            submitActive: false,
            sucesso: false,
            falha: false,
            checkBoxValue:"off",
        };
    },
    methods: {
        
        submitForm(evt) {
            evt.preventDefault();

            var form = document.querySelector('form');
            var formData = new FormData(form);
            

            var myHeaders = new Headers();
            fetch('https://www.lg.com.br/integra-pardot/', {
                method: 'POST',
                body: formData,
                headers:myHeaders,
            }).then(function(response){
                if (response.ok) {
                    conversaoGoogle();
                    conversaoFacebook();
                    return response;
                } else if (!response.ok){
                    this.falha = true;
                }
            })
            .then((data) => {
                
                this.resetForm();
            });

            this.$emit("visualizouPage3");
            setTimeout(function() {
                this.$scrollTo('.page4');
            }.bind(this), 400)

        },
        preventNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                return true;
            } else {
                evt.preventDefault();
            }
        },
        checkBox(evt){
            if(this.checkBoxValue == "off"){
                this.checkBoxValue = "on";
                this.form = Object.assign({}, this.form, {
                    "opt-in":"on"
                })
            } else{
                this.checkBoxValue = "off";
                this.form = Object.assign({}, this.form, {
                    "opt-in":"off"
                })
            }
            this.checkInput();


        },
        checkInput() {
            if (
                !this.form.nome ||
                !this.form.sobrenome ||
                !this.form.email ||
                !this.form.empresa ||
                !this.form.nfunc ||
                !this.form.cargo ||
                !this.form.departamento ||
                !this.form.cidade ||
                !this.form.estado ||
                !this.form.telefone

            ) {
                this.submitActive = false;
            } else {
                this.submitActive = true;
            }
        },

        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        resetForm() {
            this.form.nome = 
            this.form.sobrenome = 
            this.form.email = 
            this.form.empresa = 
            this.form.cargo = 
            this.form.departamento = 
            this.form.cidade = 
            this.form.estado = 
            this.form.telefone = "";
            
            this.form.nfunc = null;
            this.form.estado = null;
            this.sucesso = true;
        },
    },
    created: function () {
        this.piAId = "689633";
        this.piCId = "1611";
        this.piHostname = "pi.pardot.com";

        (function () {
            function async_load() {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src =
                    ("https:" == document.location.protocol
                        ? "https://pi"
                        : "http://cdn") + ".pardot.com/pd.js";
                var c = document.getElementsByTagName("script")[0];
                c.parentNode.insertBefore(s, c);
            }
            if (window.attachEvent) {
                window.attachEvent("onload", async_load);
            } else {
                window.addEventListener("load", async_load, false);
            }
        })();
    },
};
</script>

<style lang="scss" scoped>
.page3 {
    transition: 0.5s;
    position: relative;
    background-image: url("~@/assets/img/page2-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 40px;
    padding-bottom: 40px;
    #form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .text-sm{
        font-size: 0.7rem;
    }
    .checkBox{
        margin-right: auto;
    }
    
    .conteudo-reverse {
        align-items: flex-start;
        .col1 {
            width: 556px;
            flex-basis: 0;
            flex-grow: 1;
        }
        .col2 {
            width: 556px;
            flex-basis: 0;
            flex-grow: 1;
            img {
                max-width: 100%;
            }
        }
    }
    .campoForm {
        border-radius: 4px;
        padding-left: 10px;
        font-size: 1rem;
        height: 35px;
        width: 100%;
        width: 556px;
        border: 1px solid $color-yellow;
        margin-bottom: 10px;
        color: $color-french-grey;

        -ms-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
        -webkit-box-sizing: content-box;

        outline: none;
    }
    .select {
        width: 558px;
        color: #ced4da;
    }
    .selectAlt {
        color: $color-french-grey;
    }

    .btnEnviarDisabled {
        font-size: 1rem;
        height: 40px;
        width: 268px;
        border-radius: 60px;
        border: 1px solid $color-red;
        background: none;
        color: $color-red;
        pointer-events: none;
        user-select: none;
    }
    .buttonAlign {
        align-self: flex-end;
    }
    .btnEnviarEnabled {
        border: none;
        background: $color-yellow;
        color: white;
        cursor: pointer;
        pointer-events: auto;
        user-select: none;
    }
    .btnEnviarEnabled:hover {
        border: 2px solid $color-orange;
        background: #ffcb44;
    }
    ::placeholder {
        color: #ced4da;
    }
    ul {
        list-style-type: none;
    }
    @media (max-width: 1250px) {
        .conteudo-reverse {
            align-items: flex-start;
            max-width: 100%;
            width: 100%;
            .col1 {
                padding-left: 10px;
                padding-right: 10px;
                width: 100%;
                flex-basis: 0;
                flex-grow: 1;
            }
            .col2 {
                display: none;
            }
        }
    }
    @media (max-width: 900px) {
        .campoForm {
            border-radius: 4px;
            padding-left: 10px;
            font-size: 1rem;
            height: 35px;
            max-width: 100%;
            width: 90%;
            border: 1px solid $color-yellow;
            margin-bottom: 10px;
            color: $color-french-grey;

            -ms-box-sizing: content-box;
            -moz-box-sizing: content-box;
            box-sizing: content-box;
            -webkit-box-sizing: content-box;

            outline: none;
        }
        .select {
            max-width: 100%;
            width: 91%;
            color: #ced4da;
        }
        .buttonAlign {
            align-self: center;
        }
    }
}
</style> 